import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.COMBINED_BILL_SET_COMBINED_BILL_LIST]: (state, payload) => {
    state.combinedBillList = payload.combinedBillList
    /*
    const sortNumberList = payload.combinedBillList.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.maxSortNumber = Math.max(...sortNumberList)
    }
    */
  }
}

export default Mutations
